import { set, when } from 'cerebral/operators'

import isSameAsLoggedInUser from '../actions/isSameAsLoggedInUser.js'
import moveUnApprovedUserToApproved from '../actions/moveUnApprovedUserToApproved.js'
import saveUser from '../actions/saveUser.js'
import setCurrentUser from '../actions/setCurrentUser.js'
import setFormErrorMessages from '../actions/setFormErrorMessages.js'
import setFormNotSubmitting from '../actions/setFormNotSubmitting.js'
import setFormSubmitting from '../actions/setFormSubmitting.js'
import setFormValidation from '../actions/setFormValidation.js'
import setFormValidationForErrorMessage from '../actions/setFormValidationForErrorMessage.js'
import shouldRemoveUnApprovedView from '../actions/shouldRemoveUnApprovedView.js'
import showSaveUserSuccessSnackbar from '../actions/showSaveUserSuccessSnackbar.js'
import updateApprovedUsersArray from '../actions/updateApprovedUsersArray.js'
import validateAllUserForms from '../actions/validateAllUserForms.js'
import showSaveUserFailSnackbar from '../actions/showSaveUserFailSnackbar'
import showNewPasswordDialogOnValidationError from '../actions/showNewPasswordDialogOnValidationError'
import setUser from '../actions/setUser'

export default [
  setFormSubmitting,
  validateAllUserForms,
  {
    true: [
      saveUser,
      {
        success: [
          setCurrentUser,
          {
            doesExist: [],
            isDeleted: []
          },
          isSameAsLoggedInUser,
          {
            true: [setUser],
            false: []
          },
          when('state:users.currentView', ['unapproved']),
          {
            unapproved: [
              moveUnApprovedUserToApproved,
              shouldRemoveUnApprovedView,
              {
                true: [set('state:users.currentView', 'approved')],
                false: []
              }
            ],
            otherwise: [
              isSameAsLoggedInUser,
              {
                true: [],
                false: [updateApprovedUsersArray]
              }
            ]
          },
          setFormValidation,
          showSaveUserSuccessSnackbar,
          setFormNotSubmitting
        ],
        error: [
          setFormErrorMessages,
          showSaveUserFailSnackbar,
          setFormValidationForErrorMessage,
          setFormNotSubmitting
        ]
      }
    ],
    false: [
      setFormValidation, showNewPasswordDialogOnValidationError, showSaveUserFailSnackbar, setFormNotSubmitting]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/saveAccount.js